export const ExtractReferenceCode: (value: string) => string = value => (value.match(/id\/[^/]+\/[^/]+$/) || [''])[0];
